// VENDOR MODULES
import {FormlyFieldConfig, FormlyFormOptions, FieldArrayType} from '@ngx-formly/core';

// INTERFACE DEFINITIONS

export type CellTemplate =
    | 'contact_details'
    | 'ddMMyyyy'
    | 'ddMMyyyyHHmmss'
    | 'delete'
    | 'empty'
    | 'exp'
    | 'exp_badge'
    | 'gender'
    | 'id'
    | 'identifiers'
    | 'json'
    | 'memberperson'
    | 'membership'
    | 'memberships'
    | 'org_members'
    | 'organization'
    | 'patchselect'
    | 'person'
    | 'personlink'
    | 'sep_num'
    | 'simil_add'
    | 'simil_bind'
    | 'text';

export type HeaderTemplate = 'hdr' | 'hdr_exp' | 'hdr_sel';

export type RowDetailType = 'form' | 'table';

export interface ListTPL {
    title: string;
    columns: ColumnsTPL[];
    filters: FormlyFieldConfig[];
    actions: FormlyFieldConfig[];
    options: ListTPLOptions;
    prefetch: any
}

export class ListTPLOptions {
    supports_creation?: boolean;
    creation_params?: any;
    csv_export_opts?: any;
    row_detail?: {
        title: string;
        type: RowDetailType;
        rowHeight?: any;
        datasource?: any;
        datasourceParams?: any;
        fields?: Array<any>;
        fieldGroup?: any;
        fieldArray?: FieldArrayType;
    };

    constructor() {
        this.supports_creation = true;
    }
}

export interface FormTPL {
    title: string;
    fields: FormlyFieldConfig[];
    options: FormlyFormOptions;
}

export interface ColumnsTPL {
    name: string;
    prop: string;
    head: HeaderTemplate;
    headerCheckboxable?: boolean,
    checkboxable?: boolean,
    cell: CellTemplate;
    resize: 0 | 1;
    sort: 0 | 1;
    drag: 0 | 1;
    flexGrow: number;
    width?: number;
    canAutoResize?: 0 | 1;
    sortBy?: string;
}
